import ReactTooltip from 'react-tooltip';
import { useTranslation } from 'react-i18next';

function StatusPill({ object }) {
  const { t } = useTranslation();
  let obj = {
    status: t('common:pill-submitted'),
    tooltip: t('common:pill-tooltip-submitted'),
    classes: 'bg-pill-orange text-pill-orange',
  };

  if (object.isdeactivated) {
    obj = {
      status: t('common:pill-deactivated'),
      tooltip: t('common:pill-tooltip-deactivated'),
      classes: 'bg-gray-500 text-black',
    };
  } else if (object.islocked) {
    obj = {
      status: t('common:pill-change'),
      tooltip: t('common:pill-tooltip-amendment'),
      classes: 'bg-pill-orange text-pill-orange',
    };
  } else if (object.verifiedstate !== 0 && object.changespending) {
    obj = {
      status: t('common:pill-change'),
      tooltip: t('common:pill-tooltip-amendment'),
      classes: 'bg-pill-orange text-pill-orange',
    };
  } else if (object.verifiedstate === 0) {
    obj = {
      status: t('common:pill-submitted'),
      tooltip: t('common:pill-tooltip-submitted'),
      classes: 'bg-pill-orange text-pill-orange',
    };
  } else if (object.verifiedstate === 1) {
    obj = {
      status: t('common:pill-processed'),
      tooltip: t('common:pill-tooltip-processed'),
      classes: 'bg-pill-green text-pill-green',
    };
  } else if (object.verifiedstate === 2) {
    obj = {
      status: t('common:pill-rejected'),
      tooltip: t('common:pill-tooltip-rejected'),
      classes: 'bg-red-700 text-red-700',
    };
  }

  return (
    <div>
      <ReactTooltip effect="solid" multiline />
      <div data-tip={obj.tooltip} className={`inline-block text-xxs text-center py-0 px-1 rounded uppercase bg-opacity-25 ${obj.classes}`}>
        {obj.status}
      </div>
    </div>
  );
}

export default StatusPill;
